'use client';
import Icon from '@/components/ui/AppIcon';

const RecentTests = () => {
  const tests: any[] = [];

  const formatDate = (dateString: string) => {
    const date = new Date(dateString + 'T00:00:00');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}`;
  };

  const getScoreColor = (percentage: number) => {
    if (percentage >= 90) return 'text-success';
    if (percentage >= 80) return 'text-primary';
    if (percentage >= 70) return 'text-warning';
    return 'text-error';
  };

  return (
    <section className="bg-card rounded-2xl p-6 md:p-8 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground mb-1">Recent Tests</h2>
          <p className="text-sm text-muted-foreground">Your test history and scores</p>
        </div>
        <Icon name="ClipboardDocumentListIcon" size={24} className="text-muted-foreground" />
      </div>

      {tests.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">
          <Icon name="ClipboardDocumentListIcon" size={48} className="mx-auto mb-4 opacity-50" />
          <p>No test history yet</p>
          <p className="text-sm mt-2">Complete your first test to see your results here</p>
        </div>
      ) : (
        <>
          <div className="space-y-3">
            {tests?.map((test) => (
              <div
                key={test?.id}
                className="p-4 bg-background rounded-xl border border-border hover:border-accent/50 transition-colors"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground mb-1">{test?.title}</h3>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="CalendarIcon" size={14} />
                        {formatDate(test?.date)}
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="ClockIcon" size={14} />
                        {test?.duration}
                      </span>
                      <span className="px-2 py-0.5 bg-muted rounded text-xs font-medium">{test?.mode}</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className={`text-2xl font-bold ${getScoreColor(test?.percentage)}`}>{test?.percentage}%</div>
                    <div className="text-xs text-muted-foreground">
                      {test?.score}/{test?.total}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="w-full mt-4 px-4 py-3 bg-secondary text-foreground font-semibold rounded-xl hover:bg-secondary/80 transition-colors flex items-center justify-center gap-2">
            View All Tests
            <Icon name="ArrowRightIcon" size={16} />
          </button>
        </>
      )}
    </section>
  );
};

export default RecentTests;